import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import GameTopBar from 'components/GameTopBar';
import Game from 'components/Game';
import Layout from 'components/Layout';
import { useUnlimited, useGame } from 'common/state';

function UnlimitedScreen() {
  const [unlimitedState, unlimitedActions] = useUnlimited();
  const [gameState, gameActions] = useGame();
  const { language } = useParams();

  useEffect(() => {
    unlimitedActions.load(language);
  }, [unlimitedActions, language]);

  useEffect(() => {
    if (
      unlimitedState.status === 'loaded' &&
      (unlimitedState.gameId !== gameState.id ||
        unlimitedState.language !== gameState.language)
    ) {
      gameActions.prepare(
        unlimitedState.language,
        unlimitedState.gameId,
        'Unlimited',
        unlimitedState.gameSpec,
        null,
        'unlimited',
      );
    }
  }, [unlimitedState, gameState, gameActions]);

  return (
    <Layout>
      <GameTopBar />
      {unlimitedState.status === 'loaded' &&
        gameState.status !== 'unprepared' && <Game />}
    </Layout>
  );
}

export default UnlimitedScreen;
